<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				充值订单详情
				<el-button
				plain
				v-if="detail.isHaveInvoices==false&&$buttonAuthority('dingdan-saleOrder-addedit')"
				size="mini"
				style="margin-left:10px;"
				type="warning"
				@click="addIsHaveInvoices">
				添加发票
				</el-button>
				<el-button
				plain
				v-if="detail.isHaveInvoices==true&&$buttonAuthority('dingdan-saleOrder-addedit')"
				size="mini"
				style="margin-left:10px;"
				type="warning"
				@click="delIsHaveInvoices">
				删除发票
				</el-button>
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">订单编号：</div>
				<div class="msgValue">
					{{detail.no}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单类型：</div>
				<div class="msgValue">
					<span v-if="detail.order_source===2">余额充值</span>
					<span v-if="detail.order_source===3">押金充值</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">顾客：</div>
				<div class="msgValue">{{detail.user_info.nick_name}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">电话：</div>
				<div class="msgValue">
					{{detail.user_info.user_mobile}}
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">充值活动：</div>
				<div class="msgValue">
					<span class="msgValue" v-if="detail.activity_info">{{detail.activity_info.activity_name}}</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单状态：</div>
				<div class="msgValue">
					{{$public.formatOrderState(detail.state)}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">总计：</div>
				<div class="msgValue">￥{{detail.price}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">销售人员：</div>
				<div class="msgValue">
					<span v-for="(item,index) in detail.sales_list" :key="index">{{item.sales_name}} </span>
					<el-button v-if="$buttonAuthority('dingdan-saleOrder-changeStaff')" type="text" @click="changeStaff(detail)">修改</el-button>
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">订单备注：</div>
				<div class="msgValue">
					<el-popover placement="top-start" width="200" trigger="hover" :content="detail.remark">
						<div slot="reference" style="display:inline-block;width:150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;cursor: pointer;">{{detail.remark}}</div>
					</el-popover>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">创建人：</div>
				<div class="msgValue">
					{{detail.create_manager_name}}
				</div>
			</div>
			<div class="msgItem" style="width:50%;">
				<div class="msgLabel">操作时间：</div>
				<div class="msgValue">
					{{$public.FTime(detail.create_time)}}
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">结算方式：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						<span style="padding-right: 30px;" v-for="(item,index) in detail.pay_info.pay_list" :key="index">
							<span style="padding-right: 2px;">
								{{$public.formatPayTypeState(item.pay_type)}}
							</span>
							{{Math.abs((item.money).toFixed(2))}}
						</span>
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">结算备注：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						{{detail.pay_info.pay_remark}}
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">结算时间：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						{{$public.FTime(detail.pay_info.pay_time)}}
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">发票状态：</div>
				<div class="msgValue">
					{{detail.isHaveInvoices==true?'已添加':'未添加'}}
				</div>
			</div>
		</div>
		<div class="pageConBox" v-if="detail._id">
			<el-table :data="tableData" max-height='800' style="width: 100%;margin-bottom: 20px;" row-key="customCode"
			:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}" default-expand-all>
				<el-table-column label="商品名称">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'赠品':scope.row.goodsName):
							scope.row.goodsName
						}}
					</template>
				</el-table-column>
				<el-table-column prop="customCode" label="条码" width="150">
					<template slot-scope="scope">
						{{scope.row.goodsList?'':scope.row.customCode}}
					</template>
				</el-table-column>
				<el-table-column label="规格" width="200">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.skus_type):
							scope.row.skus_type
						}}
					</template>
				</el-table-column>
				<el-table-column label="单位" width="80">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.unit):
							scope.row.unit
						}}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="originalPrice" label="标准价" width="100">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.originalPrice):
							scope.row.originalPrice
						}}
					</template>
				</el-table-column> -->
				<el-table-column prop="price" label="优惠价" width="150">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.price):
							scope.row.price
						}}
					</template>
				</el-table-column>
				<el-table-column prop="num" label="数量" width="100">
				</el-table-column>
				<el-table-column label="总金额" width="120">
					<template slot-scope="scope">
						{{
							scope.row.gift=='gift'?0:((scope.row.price*scope.row.num).toFixed(2))||(scope.row.price).toFixed(2)
						}}
					</template>
				</el-table-column>
				<el-table-column prop="staff" label="销售人员">
				</el-table-column>
				<!-- <template slot="empty">
					<img src="../../assets/img/kong.png" style="width: 335px;padding-top:50px;" />
				</template> -->
				<el-table-column v-if="detail.state==3 && $buttonAuthority('dingdan-saleOrder-tuihuo')" label="退换货" width="150">
					<template slot-scope="scope">
						<!-- 判断父级 -->
						<el-checkbox v-if="scope.row.goodsList && scope.row.goodsList.length == 0 && detail.order_type_id != 6 && detail.order_type_id != 8 && detail.order_type_id != 9" v-model="scope.row.returnState"></el-checkbox>
						<!-- 判断子级 -->
						<el-checkbox v-if="!scope.row.goodsList && detail.order_type_id != 6 && detail.order_type_id != 8 && detail.order_type_id != 9" v-model="scope.row.returnState"></el-checkbox>
					</template>
				</el-table-column>
			</el-table>
			<el-row style="padding-top:20px;">
				<el-col v-if="detail.state == 3 && $buttonAuthority('dingdan-saleOrder-tuikuan')" :span="3" :offset="21">
					<el-button type="warning" @click="openOrderReturnGoods" size="small">退款</el-button>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="退款" :visible.sync="dialogReturnGoodsState" width="600px">
			<el-form :model="form">
				<el-form-item label="退款金额" :label-width="formLabelWidth">
					<el-input-number v-model="form.returnPrice" :min="0" label="描述文字"></el-input-number>
				</el-form-item>
				<el-form-item label="余额扣除金额" :label-width="formLabelWidth">
					<el-input-number v-model="form.deductionPrice" :min="0" label="描述文字"></el-input-number>
				</el-form-item>
				<el-form-item label="退款备注" :label-width="formLabelWidth">
					<el-input v-model="form.returnRemark" autocomplete="off" type="textarea" style="width:400px" placeholder="请输入退款备注15字以上" resize="none"></el-input>
				</el-form-item>
			</el-form>
			<el-row>
				<el-col v-if="detail.order_source===3" style="text-align: right;padding: 0 40px;font-size: 24px;font-weight: bold;">剩余押金:{{user_yajin}}</el-col>
				<el-col v-else style="text-align: right;padding: 0 40px;font-size: 16px;font-weight: bold;">账户余额:{{user_yue}}</el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				
				<el-button @click="dialogReturnGoodsState = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleReturnClick" size="small">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="dialogSettlementState" :type="'returnGoods'" :orderId="returnOrderId" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<!-- 修改销售人员 -->
		<div v-if="curStaffId_state">
			<el-dialog title="修改销售人员" :visible="true" width="300px" @close="curStaffId_state=false" :close-on-click-modal="false">
				<div>
					<el-select
					v-model="curStaffId"
					multiple
					filterable
					placeholder="请选择"
					size="mini">
						<el-option popper-class="select" v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item._id"></el-option>
					</el-select>
				</div>
				<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="curStaffId_state = false">取 消</el-button>
				<el-button size="mini" type="warning" @click="submit_curStaffId">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{dialogSettlement},
		data(){
			return{
				detail:{
					user_info:{},
					recharge_item_list:[],
					pay_info:{},
				},
				formLabelWidth: '120px',
				tableData: [],
				returnGoods:[],  //退货商品列表
				dialogReturnGoodsState:false,
				dialogSettlementState:false,
				returnOrderId:'', // 退换货订单ID
				form:{   //退款弹框内表单
					returnPrice:'',
					returnRemark:"",
					deductionPrice:'',
				},
				user_yue:0,  //个人余额
				user_yajin:0, // 个人押金
				
				// 修改销售人员
				curStaffId_state:false,
				curStaffId:[],
				staffList:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getDetail();
			this.getStaffList()
		},
		methods: {
			// 结算完成关闭弹窗
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.getDetail();
					// this.$router.push({path:'/orderReturnGoods/orderReturnGoodsSee',query:{id:this.returnOrderId}})
				}
			},
			//退款确定
			handleReturnClick(){
				if(this.detail.order_source===3){ // 押金
					if(this.form.returnPrice == '' || this.form.returnPrice == 0){
						this.$message({
							message: '请输入退款金额',
							type: 'error'
						});
						return
					}
					if(this.form.returnRemark.length < 15){
						this.$message({
							message: '退款备注需15字以上',
							type: 'error'
						});
						return
					}
					if(this.form.returnPrice > this.detail.price){
						this.$message({
							message: '退款金额不能超过订单金额',
							type: 'error'
						});
						return
					}
					if(this.form.returnPrice > this.user_yajin){
						this.$message({
							message: '退款金额不能超过押金余额',
							type: 'error'
						});
						return
					}
					let params = {
						"orderNum": this.detail.no,
						"remark": this.form.returnRemark,
						"price": Number(this.form.returnPrice),
					}
					this.$http.post('/api/ReturnOrder/ReturnYajinRecharge', params).then(res => {
						if(res.code == 0){
							// this.returnOrderId = res.data;  // 财务人员主动转账
							this.$nextTick(()=>{
								this.$message({
									message: '退款申请已提交成功, 请等待财务审核',
									type: 'success'
								});
							})
							this.dialogReturnGoodsState = false;
							// this.dialogSettlementState = true;
							this.getDetail();
						}
					})
				}else{  // 余额
					if(this.form.returnPrice == '' || this.form.returnPrice == 0){
						this.$message({
							message: '请输入退款金额',
							type: 'error'
						});
						return
					}
					if(this.form.returnRemark.length < 15){
						this.$message({
							message: '退款备注需15字以上',
							type: 'error'
						});
						return
					}
					if(this.form.returnPrice > this.detail.price){
						this.$message({
							message: '退款金额不能超过充值金额',
							type: 'error'
						});
						return
					}
					if(this.form.returnPrice > this.user_yue){
						this.$message({
							message: '退款金额不能超过余额',
							type: 'error'
						});
						return
					}
					if(this.form.deductionPrice == '' || this.form.deductionPrice == 0){
						this.$message({
							message: '请输入余额扣除金额',
							type: 'error'
						});
						return
					}
					if(this.form.deductionPrice < this.form.returnPrice){
						this.$message({
							message: '余额扣除金额不能小于退款金额',
							type: 'error'
						});
						return
					}
					let params = {
						rechargeOrderNumber:this.detail.no,
						remark:this.form.returnRemark,
						price:this.form.returnPrice,
						deductionPrice:this.form.deductionPrice, // deductionPrice
						isInRepository:true,
						isAllReturn:false,
						returnGoods:this.returnGoods
					}
					this.$http.post('/api/ReturnOrder/ReturnRechargeRequest', params).then(res => {
						if(res.code == 0){
							// this.returnOrderId = res.data;
							console.log('退货提交成功',res.data)
							this.$nextTick(()=>{
								this.$message({
									message: '退款申请已提交成功, 请等待财务审核',
									type: 'success'
								});
							})
							this.dialogReturnGoodsState = false;
							// this.dialogSettlementState = true;
							this.getDetail();
						}
					})
				}
			},
			//显示退款弹框
			openOrderReturnGoods(){
				this.$http.get('/api/Member/Single', {"id": this.detail.user_info.user_id}).then(res => {
					if(res.code==0){
						console.log('个人信息',res)
						this.user_yue = res.data.card_info.user_yue
						this.user_yajin = res.data.card_info.user_yajin
					}
				})
				
				if(this.detail.order_source===3){ // 押金退款
					this.dialogReturnGoodsState = true;
					return ;
				}
				// 否则为充值退款
				this.returnGoods = [];
				for(let i=0;i<this.tableData.length;i++){
					if(this.tableData[i].goodsList.length > 0){ // 判断有码
						for(let a=0;a<this.tableData[i].goodsList.length;a++){
							if(this.tableData[i].goodsList[a].returnState){ // 选中
								let one = {
									"goodsId": this.tableData[i].goodsId,
									"goodsName":  this.tableData[i].goodsName,
									"goodsType": 1,
									"skus":  this.tableData[i].skus,
									"skuValue":  this.tableData[i].skuValue,
									"model":  this.tableData[i].model,
									"unit":  this.tableData[i].unit,
									"originalPrice": this.tableData[i].originalPrice,
									"price": this.tableData[i].price,
									"num": 1,
									"remark":  this.tableData[i].remark,
									goodsList:[],
								}
								let two = {
									"goodsId": this.tableData[i].goodsList[a].goodsId,
									"goodsName": this.tableData[i].goodsList[a].goodsName,
									"customBarCode": this.tableData[i].goodsList[a].customCode,
									"specificationPrice": 0, // 商品规格单价
									"price": this.tableData[i].goodsList[a].price,
									"skus": this.tableData[i].goodsList[a].skus,
									"skuValue": this.tableData[i].goodsList[a].skuValue,
									"model":this.tableData[i].goodsList[a].model,
									"unit": this.tableData[i].goodsList[a].unit,
									"expiryDate": this.tableData[i].goodsList[a].validityStopDate,
									"isOut": true
								}
								one.goodsList.push(two);
								this.returnGoods.push(one);
							}
						}
						console.log('有码退货',this.returnGoods)
					}else{  //判断无码
						if(this.tableData[i].returnState){ // 选中
							let one = {
								"goodsId": this.tableData[i].goodsId,
								"goodsName":  this.tableData[i].goodsName,
								"goodsType": 1,
								"skus":  this.tableData[i].skus,
								"skuValue":  this.tableData[i].skuValue,
								"model":  this.tableData[i].model,
								"unit":  this.tableData[i].unit,
								"originalPrice": this.tableData[i].originalPrice,
								"price": this.tableData[i].price,
								"num": 1,
								"remark":  this.tableData[i].remark,
								goodsList:[],
							}
							this.returnGoods.push(one);
						}
						console.log('无码退货',this.returnGoods)
					}
				}
				if(this.tableData.length>0&&this.returnGoods.length==0){
					this.$confirm('未选择赠品,是否需要选择赠品?', '提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning'
					}).then(() => {
						console.log('选择赠品复选框')
					}).catch(() => {
						this.dialogReturnGoodsState = true;    
					});
				}else{
					console.log(this.returnGoods)
					this.dialogReturnGoodsState = true;
				}
			},
			// 获取详情
			getDetail(){
				this.$http.get(process.env.VUE_APP_Url_order+'/api/OffLineRecharge/'+this.$route.query.id).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
						// this.detail.pay_info=JSON.parse(this.detail.pay_info);
						console.log('详情',this.detail)
						for(let i=0;i<this.detail.recharge_item_list.length;i++){
							let one = {
								activityId: '', // 活动id
								activityName: '', // 活动名称
								goodsDosage: "", // 用量
								goodsId: this.detail.recharge_item_list[i].goods_id, // 商品id
								goodsName: this.detail.recharge_item_list[i].goods_name, // 商品名称
								goodsList: [], // children
								goodsType:  this.detail.recharge_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
								goodsUsage: "", // 用法
								isPay: this.detail.state, // 是否支付
								num:this.detail.recharge_item_list[i].num, // 数量
								originalPrice: this.detail.recharge_item_list[i].original_price, // 原价
								price: this.detail.recharge_item_list[i].original_price, // 现价
								remark: this.detail.recharge_item_list[i].remark, // 备注
								skuValue: this.detail.recharge_item_list[i].skuValue, // 规格
								skus: this.detail.recharge_item_list[i].skuValue, // 规格
								totalMoney: '', // 总价
								unit: this.detail.recharge_item_list[i].unit, // 单位
								staff: '',
								sales_list: [],
								validityStopDate:'',
								returnState:false
							}
							if(this.detail.sales_list){
								one.sales_list = this.detail.sales_list;
								for(let b=0;b<this.detail.sales_list.length;b++){
									one.staff+=this.detail.sales_list[b].sales_name+' '
								}
							}
							if(this.detail.recharge_item_list[i].goods_type==2 || this.detail.recharge_item_list[i].goods_type==4){ // 服务
								one.customCode = 'service'+this.detail.recharge_item_list[i].goods_id;
							}else if(this.detail.recharge_item_list[i].goods_type==0){ // 商品
								one.customCode = 'goods'+this.detail.recharge_item_list[i].goods_id;
								if(this.detail.recharge_item_list[i].recharge_item_goods_list){
									for(let a=0;a<this.detail.recharge_item_list[i].recharge_item_goods_list.length;a++){
										one.goodsName = this.detail.recharge_item_list[i].recharge_item_goods_list[a].goods_name;
										one.unit = this.detail.recharge_item_list[i].recharge_item_goods_list[a].unit;
										let two = {
											customCode: this.detail.recharge_item_list[i].recharge_item_goods_list[a].custom_code,
											activityId: "", // 活动id
											activityName: "", // 活动名称
											goodsDosage: "", // 用量
											goodsId: this.detail.recharge_item_list[i].recharge_item_goods_list[a].goods_id, // 商品id
											goodsName: this.detail.recharge_item_list[i].recharge_item_goods_list[a].goods_name, // 商品名称
											goodsType: this.detail.recharge_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
											goodsUsage: "", // 用法
											isPay: this.detail.state, // 是否支付
											num: 1, // 数量
											originalPrice: this.detail.recharge_item_list[i].original_price, // 原价
											price: this.detail.recharge_item_list[i].original_price, // 现价
											remark: this.detail.recharge_item_list[i].remark, // 备注
											skuValue: this.detail.recharge_item_list[i].skuValue, // 规格
											skus: this.detail.recharge_item_list[i].skuValue, // 规格
											totalMoney: '', // 总价
											unit: this.detail.recharge_item_list[i].recharge_item_goods_list[a].unit, // 单位
											validityStopDate:this.detail.recharge_item_list[i].recharge_item_goods_list[a].validity_stop_date,
											returnState:false
										}
										one.goodsList.push(two);
									}
								}
							}
							this.tableData.push(one);
							console.log(this.tableData)
						}
					}
				})
			},
			// 是否发票
			addIsHaveInvoices(){
				let params = {
					order_id:this.detail._id
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_order+'/api/OffLineRecharge/AddInvoicesAsync', params).then(res => {
					loading.close()
					if(res.code===0){
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getDetail()
					}
				})
			},
			delIsHaveInvoices(){
				let params = {
					order_id:this.detail._id
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_order+'/api/OffLineRecharge/DeleteInvoicesAsync', params).then(res => {
					loading.close()
					if(res.code===0){
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getDetail()
					}
				})
			},
			// 修改销售人员
			changeStaff(detail){
				this.curStaffId = []
				for(let b=0;b<detail.sales_list.length;b++){
					this.curStaffId.push(detail.sales_list[b].sales_id)
				}
				this.curStaffId_state = true;
			},
			submit_curStaffId(){
				let sales_list = []
				for(let i=0;i<this.curStaffId.length;i++){
					sales_list.push({
						"sales_id": this.curStaffId[i],
						"sales_name": this.$public.getMatchingItem(this.staffList,'_id',this.curStaffId[i]).basic_info.nick_name,
					})
				}
				let params = {
					"order_id": this.detail._id,
					"sales_list": sales_list,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_order+'/api/OffLineRecharge/UpdateSaleMan', params).then(res => {
					loading.close()
					if(res.code===0){
						this.curStaffId_state = false;
						this.getDetail()
					}
				})
				
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.pageTitleBox{
	}
	.msg {
		display: flex;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 4px;
		.msgItem {
			width: 25%;
			font-size: 16px;
			color: $fontColor;
			display: flex;
			line-height: 40px;
			padding:0 20px;
			box-sizing: border-box;
			border-bottom:1px solid #F2F2F2;
			font-size: 12px;;
			.msgLabel {
				width: 80px;
				text-align: right;
				color: $fontColor;
			}
	
			.msgValue {}
		}
	}
	.pageConBox{
		margin-top:12px;
		min-height: 600px;
	}
}
</style>
